const updates = [
  {
    date: '2026.08.01',
    title: '长安风云录 大结局已上线',
    desc: '年度口碑古装大剧《长安风云录》全48集已更新完毕，大结局高能反转，点击立即观看完整版。',
    tag: '更新',
    tagColor: 'primary',
  },
  {
    date: '2026.07.31',
    title: '迷雾追踪 第2季全集上线',
    desc: '烧脑悬疑剧《迷雾追踪》第二季全集已上线，全新案件，更高能反转，悬疑爱好者不可错过。',
    tag: '上线',
    tagColor: 'accent',
  },
  {
    date: '2026.07.30',
    title: '韩剧专区新增5部高分好剧',
    desc: '韩剧专区重磅更新，新增《星光彼岸》《首尔之恋》等5部高分韩剧，双语字幕已就位。',
    tag: '新增',
    tagColor: 'primary',
  },
  {
    date: '2026.07.29',
    title: '遇见你的那天 播放量破百万',
    desc: '都市情感剧《遇见你的那天》总播放量突破百万大关，感谢各位剧迷的支持与厚爱。',
    tag: '里程碑',
    tagColor: 'accent',
  },
  {
    date: '2026.07.28',
    title: '美剧频道全面升级',
    desc: '美剧频道页面全新改版，新增分类筛选和智能推荐功能，找剧更方便，追剧更高效。',
    tag: '升级',
    tagColor: 'primary',
  },
  {
    date: '2026.07.27',
    title: '暑假追剧片单推荐专题上线',
    desc: '暑假特别策划「追剧片单」专题已上线，编辑精选20部必看好剧，陪你度过完美假期。',
    tag: '专题',
    tagColor: 'accent',
  },
  {
    date: '2026.07.26',
    title: '武侠经典剧场全新开放',
    desc: '武侠江湖频道正式上线，收录《江湖夜雨》等新派武侠与经典武侠剧集，武侠迷速来报到。',
    tag: '新频道',
    tagColor: 'primary',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">最新快讯</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            58影院最新动态与剧集更新资讯，追剧消息一手掌握
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((item, idx) => (
            <div
              key={idx}
              className="relative flex gap-4 pb-6 last:pb-0 group cursor-pointer"
            >
              <div className="flex-shrink-0 flex flex-col items-center">
                <div className={`w-2.5 h-2.5 rounded-full mt-1.5 ${
                  item.tagColor === 'accent' ? 'bg-accent-500' : 'bg-primary-500'
                }`}></div>
                {idx < updates.length - 1 && (
                  <div className="w-px flex-1 bg-background-200 mt-1.5 group-hover:bg-primary-200 transition-colors"></div>
                )}
              </div>

              <div className="flex-1 min-w-0 pb-2">
                <div className="flex items-center gap-3 mb-1.5 flex-wrap">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                  <span className={`px-2 py-0.5 rounded-md text-xs font-medium whitespace-nowrap ${
                    item.tagColor === 'accent'
                      ? 'bg-accent-100 text-accent-700'
                      : 'bg-primary-100 text-primary-700'
                  }`}>
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 font-heading mb-1 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}